import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { API, axios } from '../../utils/api';
import { comeData } from '../../utils/documenti';
import { linkWhatsApp } from '../../utils/percorso';
import { CONTRATTI, DA_AVERE, MAX_COMUNI, NAZIONALITA, PERMESSO_AL, PERMESSO_DAL, PIANI_RICERCA, STATI_CIVILI, TEMPI_LAVORO, TIPI_IMMOBILE, TIPI_PERMESSO, comuniAuto, comuniDa, pianiDi, senzaComune, tipiDi, zonaDi } from '../../utils/profilo';
import MappaZona from '../cliente/immobili/MappaZona';

// Moduli della scheda cliente (in riquadri, niente finestre): fissa visita, nuova proposta, aggiungi link,
// messaggio al cliente, modifica "La ricerca". Ognuno chiama le rotte di sempre e poi onFatto().

const errore = (e) => toast.error(typeof e.response?.data?.detail === 'string' ? e.response.data.detail : 'Non riuscito');

const Riquadro = ({ titolo, chiudi, children }) => (
  <div className="riquadro" data-testid={`modulo-${titolo.toLowerCase().replace(/\s+/g, '-')}`}>
    <div className="ttl" style={{ marginBottom: '.4rem' }}><h2 style={{ fontSize: '1.1rem' }}>{titolo}</h2><button type="button" className="x" onClick={chiudi} aria-label="Chiudi">✕</button></div>
    {children}
  </div>
);

export const NuovaProposta = ({ cliente, immobili, immobileId, chiudi, onFatto }) => {
  const [dati, setDati] = useState({ immobile_id: immobileId || '', prezzo_offerto: '', data_scadenza: '', caparra: '', subordinato: false, subordinato_fino_a: '', rogito_entro: '', note: '' });
  const imm = immobili.find((i) => i.id === dati.immobile_id);
  const invia = async (e) => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/clienti/${cliente.id}/proposte`, {
        immobile_id: dati.immobile_id, prezzo_offerto: dati.prezzo_offerto, prezzo_richiesto: imm?.prezzo ? String(imm.prezzo) : undefined,
        data_scadenza: dati.data_scadenza || undefined, subordinato: dati.subordinato, subordinato_fino_a: dati.subordinato_fino_a || undefined,
        rogito_entro: dati.rogito_entro || undefined, note: dati.note,
      });
      if (dati.caparra) await axios.put(`${API}/proposte/${r.data.id}`, { rogito_importo_caparra: dati.caparra });
      toast.success('Proposta creata: la scadenza è in agenda');
      onFatto();
    } catch (err) { errore(err); }
  };
  const campo = (k, props = {}) => <input value={dati[k]} onChange={(e) => setDati({ ...dati, [k]: e.target.value })} {...props} />;
  return (
    <Riquadro titolo="Nuova proposta" chiudi={chiudi}>
      <form onSubmit={invia}>
        <div className="form-griglia">
          <label>Immobile
            <select value={dati.immobile_id} onChange={(e) => setDati({ ...dati, immobile_id: e.target.value })} required>
              <option value="">Quale?</option>
              {immobili.filter((i) => i.stato_attivita !== 'scartato').map((i) => <option key={i.id} value={i.id}>{i.indirizzo || i.titolo}</option>)}
            </select>
          </label>
          <label>Prezzo offerto{campo('prezzo_offerto', { required: true, inputMode: 'numeric', placeholder: 'es. 362000' })}</label>
          <label>Caparra{campo('caparra', { inputMode: 'numeric', placeholder: 'es. 10000' })}</label>
          <label>Scadenza della proposta{campo('data_scadenza', { type: 'date' })}</label>
          <label>Rogito entro{campo('rogito_entro', { type: 'date' })}</label>
          <label>Subordinata al mutuo
            <select value={dati.subordinato ? 'si' : 'no'} onChange={(e) => setDati({ ...dati, subordinato: e.target.value === 'si' })}><option value="no">No</option><option value="si">Sì</option></select>
          </label>
          {dati.subordinato && <label>Condizione fino al{campo('subordinato_fino_a', { type: 'date' })}</label>}
        </div>
        <div className="form-riga">{campo('note', { placeholder: 'Note (facoltative)', style: { flex: 1 } })}<button type="submit" className="btn sm p">Crea la proposta</button></div>
      </form>
    </Riquadro>
  );
};

// La stessa casa può essere già in elenco con il link di un altro portale (backend/doppioni.py): prima di
// aggiungerla si chiede «questa casa è già presente da immobiliare.it: la unisco?». Si può unire il link alla
// scheda che c'è già oppure aggiungerla lo stesso come casa a sé.
export const AggiungiLink = ({ cliente, chiudi, onFatto }) => {
  const [link, setLink] = useState('');
  const [doppione, setDoppione] = useState(null);
  const aggiungi = async (unisciComunque) => {
    await axios.post(`${API}/clienti/${cliente.id}/immobili`, { link, unisci_comunque: unisciComunque });
    toast.success("Aggiunto: l'estrattore lo legge e al cliente arriva «Volete vederla?»");
    onFatto();
  };
  const invia = async (e) => {
    e.preventDefault();
    try {
      const r = await axios.post(`${API}/clienti/${cliente.id}/immobili/controlla`, { link });
      if (r.data?.doppione) { setDoppione(r.data.doppione); return; }
      await aggiungi(false);
    } catch (err) {
      if (err.response?.status === 409) { setDoppione({ avviso: err.response.data?.detail }); return; }
      errore(err);
    }
  };
  const unisci = async () => {
    try {
      await axios.post(`${API}/immobili/${doppione.immobile_id}/link-alternativo`, { link });
      toast.success('Unita alla casa che c’era già: una proposta sola');
      onFatto();
    } catch (err) { errore(err); }
  };
  return (
    <Riquadro titolo="Proponi un immobile" chiudi={chiudi}>
      <form className="form-riga" onSubmit={invia} style={{ marginTop: 0 }}>
        <input value={link} onChange={(e) => { setLink(e.target.value); setDoppione(null); }} placeholder="Link dell'annuncio (immobiliare.it, idealista, casa.it…)" aria-label="Link dell'annuncio" required style={{ flex: 1, minWidth: 240 }} />
        <button type="submit" className="btn sm p">Proponi</button>
      </form>
      {doppione && (
        <div className="avviso" role="alert" data-testid="avviso-doppione" style={{ marginTop: '.6rem' }}>
          <span>{doppione.avviso}</span>
          <div className="form-riga" style={{ marginTop: '.4rem' }}>
            {doppione.immobile_id && <button type="button" className="btn sm p" onClick={unisci}>Sì, unisci</button>}
            <button type="button" className="btn sm" onClick={() => aggiungi(true).catch(errore)}>Aggiungila lo stesso</button>
          </div>
        </div>
      )}
    </Riquadro>
  );
};

// Messaggio al cliente (app ed email) con i modelli di Impostazioni → Modelli, già riempiti con i dati del cliente;
// lo stesso testo si può aprire in WhatsApp.
export const Messaggio = ({ cliente, chiudi, onFatto }) => {
  const [dati, setDati] = useState({ titolo: '', messaggio: '' });
  const [modelli, setModelli] = useState([]);
  const [telefono, setTelefono] = useState(null);
  useEffect(() => {
    axios.get(`${API}/clienti/${cliente.id}/modelli-messaggio`).then((r) => { setModelli(r.data.modelli); setTelefono(r.data.telefono); }).catch(() => {});
  }, [cliente.id]);
  const scegli = (id) => {
    const m = modelli.find((x) => x.id === id);
    if (m) setDati({ titolo: m.oggetto_pronto || m.nome, messaggio: m.testo_pronto });
  };
  const wa = linkWhatsApp(telefono);
  const invia = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/clienti/${cliente.id}/notifiche`, { ...dati, tipo: 'aggiornamento' });
      toast.success('Messaggio inviato: lo trova nell’app e per email');
      onFatto();
    } catch (err) { errore(err); }
  };
  return (
    <Riquadro titolo="Messaggio al cliente" chiudi={chiudi}>
      <form onSubmit={invia}>
        <div className="form-riga" style={{ marginTop: 0 }}>
          {modelli.length > 0 && (
            <select defaultValue="" onChange={(e) => scegli(e.target.value)} aria-label="Modello">
              <option value="" disabled>Da un modello…</option>
              {modelli.map((m) => <option key={m.id} value={m.id}>{m.nome}</option>)}
            </select>
          )}
          <input value={dati.titolo} onChange={(e) => setDati({ ...dati, titolo: e.target.value })} placeholder="Oggetto" aria-label="Oggetto" required style={{ flex: 1 }} />
        </div>
        <div className="form-riga">
          <textarea value={dati.messaggio} onChange={(e) => setDati({ ...dati, messaggio: e.target.value })} placeholder="Il messaggio" aria-label="Messaggio" required rows={3} style={{ flex: 1 }} />
          <button type="submit" className="btn sm p">Invia</button>
          {wa && dati.messaggio && <a className="btn sm wa" href={`${wa}?text=${encodeURIComponent(dati.messaggio)}`} target="_blank" rel="noopener noreferrer">Apri in WhatsApp</a>}
        </div>
      </form>
    </Riquadro>
  );
};

// "Profilo e ricerca" (La ricerca → Modifica): gli stessi campi che il cliente vede nel suo profilo (ricerca, lavoro e
// famiglia, dati) più quelli solo dello staff (mutuo, pre-delibera, numero del documento). La ricerca ha tutto quello
// che usano la ricerca automatica e le case in archivio: budget minimo e massimo, i comuni (fino a MAX_COMUNI, anche
// disegnando la zona sulla mappa), zone, tipo, locali, bagni e metri minimi, piano, giardino, terrazzo o balcone, box.
const CAMPI_RICERCA = [
  ['budget_min', 'Budget minimo', 'numeric'], ['budget_max', 'Budget massimo', 'numeric'], ['citta_ricerca', `Comuni (fino a ${MAX_COMUNI})`],
  ['zone_preferite', 'Zone o vie preferite'], ['locali_min', 'Locali minimi', 'numeric'], ['bagni_min', 'Bagni minimi', 'numeric'],
  ['metratura_min', 'Metri quadri minimi', 'numeric'],
];
const CAMPI_MUTUO = [
  ['percentuale_mutuo', 'Mutuo %', 'numeric'], ['importo_mutuo_max', 'Mutuo fino a', 'numeric'],
  ['pre_delibera_banca', 'Pre-delibera: banca'], ['pre_delibera_importo', 'Pre-delibera: importo', 'numeric'],
];
const CAMPI_PROFILO = [
  ['nazionalita', 'Nazionalità'], ['tempo_in_italia', 'In Italia da'], ['tipo_contratto', 'Lavoro', CONTRATTI], ['tempo_lavoro', 'Da quanto lavora', TEMPI_LAVORO],
  ['fatturato_730', 'Reddito dal 730 (€)', 'numeric'], ['stato_civile', 'Stato civile', STATI_CIVILI], ['nucleo_familiare', 'Persone in famiglia', 'numeric'],
  ['data_di_nascita', 'Data di nascita', 'date'], ['codice_fiscale', 'Codice fiscale'], ['numero_documento', 'Numero del documento'],
  ['indirizzo_residenza', 'Indirizzo di residenza'],
];
const TESTO_NON_NUMERO = ['budget_min', 'budget_max', 'metratura_min'];  // nel profilo sono testo

// Il permesso di soggiorno, una riga per ogni persona del nucleo: il titolare sta nel profilo del cliente
// (PUT /clienti/{id}), ogni familiare nel suo (PUT /clienti/{id}/familiari/{fid}). La data scritta qui comanda su
// quella letta dal documento (backend/permesso_soggiorno.py), così una lettura sbagliata dell'OCR si corregge.
const permessoDi = (p) => ({ permesso_tipo: p?.permesso_tipo || '', permesso_scadenza: p?.permesso_scadenza || '' });
export const permessiCambiati = (familiari, scritti) => (familiari || []).filter((f) => {
  const adesso = scritti[f.id];
  const prima = permessoDi(f);
  return adesso && (adesso.permesso_tipo !== prima.permesso_tipo || adesso.permesso_scadenza !== prima.permesso_scadenza);
});

const Chip = ({ on, onClick, children }) => (
  <button type="button" className={`chip${on ? ' on' : ''}`} aria-pressed={on} onClick={onClick}>{children}</button>
);

export const ModificaRicerca = ({ cliente, chiudi, onFatto }) => {
  const [dati, setDati] = useState(null);
  const [familiari, setFamiliari] = useState([]);   // come stanno sul server
  const [permessi, setPermessi] = useState({});     // {id familiare: {permesso_tipo, permesso_scadenza}} scritti adesso
  useEffect(() => {
    axios.get(`${API}/clienti/${cliente.id}`).then((r) => setDati({ ...r.data, citta_ricerca: (r.data.citta_ricerca || []).join(', '),
      tipo_immobile_ricerca: tipiDi(r.data), piano_ricerca: pianiDi(r.data) })).catch(() => setDati({ tipo_immobile_ricerca: [], piano_ricerca: [] }));
    axios.get(`${API}/clienti/${cliente.id}/familiari`).then((r) => {
      const lista = Array.isArray(r.data) ? r.data : [];
      setFamiliari(lista);
      setPermessi(Object.fromEntries(lista.map((f) => [f.id, permessoDi(f)])));
    }).catch(() => setFamiliari([]));
  }, [cliente.id]);
  if (!dati) return null;
  const alterna = (k, v) => setDati({ ...dati, [k]: dati[k].includes(v) ? dati[k].filter((x) => x !== v) : [...dati[k], v] });
  const invia = async (e) => {
    e.preventDefault();
    const numero = (v) => (v === '' || v === null || v === undefined ? null : Number(String(v).replace(/[^\d]/g, '')) || null);
    const corpo = Object.fromEntries([...CAMPI_RICERCA, ...CAMPI_MUTUO, ...CAMPI_PROFILO].map(([k, , modo]) => [k,
      modo === 'numeric' && !TESTO_NON_NUMERO.includes(k) ? numero(dati[k]) : (dati[k] === '' || dati[k] === undefined ? null : dati[k])]));
    TESTO_NON_NUMERO.forEach((k) => { corpo[k] = numero(dati[k]) === null ? null : String(numero(dati[k])); });
    corpo.citta_ricerca = String(dati.citta_ricerca || '').split(',').map((c) => c.trim()).filter(Boolean);
    if (corpo.citta_ricerca.length > MAX_COMUNI) { toast.error(`Al massimo ${MAX_COMUNI} comuni`); return; }
    corpo.zona_ricerca = zonaDi(dati); // la zona disegnata sulla mappa (vuota = nessuna zona)
    corpo.tipo_immobile_ricerca = dati.tipo_immobile_ricerca;
    corpo.piano_ricerca = dati.piano_ricerca;
    DA_AVERE.forEach(([k]) => { corpo[k] = Boolean(dati[k]); });
    // il permesso del titolare va col profilo; quelli dei familiari sulla loro rotta, solo se cambiati
    corpo.permesso_tipo = dati.permesso_tipo || null;
    corpo.permesso_scadenza = dati.permesso_scadenza || null;
    try {
      await axios.put(`${API}/clienti/${cliente.id}`, corpo);
      for (const f of permessiCambiati(familiari, permessi)) {
        // uno alla volta: la lista dei familiari è un campo solo del cliente, due scritture insieme si sovrascrivono
        // eslint-disable-next-line no-await-in-loop
        await axios.put(`${API}/clienti/${cliente.id}/familiari/${f.id}`, {
          permesso_tipo: permessi[f.id].permesso_tipo || null, permesso_scadenza: permessi[f.id].permesso_scadenza || null });
      }
      toast.success('Profilo aggiornato');
      onFatto();
    } catch (err) { errore(err); }
  };
  const nomeDi = (p) => `${p.nome || ''} ${p.cognome || ''}`.trim() || 'Titolare';
  // una persona per riquadro: tipo e scadenza restano vicini anche quando la griglia va a capo
  const rigaPermesso = (nome, valori, cambia, chiave) => (
    <div className="permesso-persona" key={chiave}>
      <span className="chi">{nome}</span>
      <div className="form-griglia">
        <label>Tipo di permesso
          <select value={valori.permesso_tipo || ''} onChange={(e) => cambia('permesso_tipo', e.target.value)} aria-label={`${nome}: tipo di permesso`}>
            <option value="">—</option>{TIPI_PERMESSO.map(([v, n]) => <option key={v} value={v}>{n}</option>)}
          </select>
        </label>
        <label>Scadenza
          <input type="date" value={valori.permesso_scadenza || ''} min={PERMESSO_DAL} max={PERMESSO_AL}
            aria-label={`${nome}: scadenza del permesso`} onChange={(e) => cambia('permesso_scadenza', e.target.value)} />
        </label>
      </div>
    </div>
  );
  const campo = ([k, nome, modo]) => (
    <label key={k}>{nome}
      {Array.isArray(modo) ? (
        <select value={dati[k] || ''} onChange={(e) => setDati({ ...dati, [k]: e.target.value })}>
          <option value="">—</option>{modo.map(([v, n]) => <option key={v} value={v}>{n}</option>)}
        </select>
      ) : <input value={dati[k] ?? ''} type={modo === 'date' ? 'date' : 'text'} inputMode={modo === 'numeric' ? 'numeric' : undefined}
        list={k === 'nazionalita' ? 'nazionalita-staff' : undefined} placeholder={k === 'citta_ricerca' ? 'con la virgola: Vimercate, Arcore' : undefined}
        onChange={(e) => setDati({ ...dati, [k]: e.target.value })} />}
    </label>
  );
  // i comuni con l'etichetta: solo quelli ancora scritti nel campo (la ✕ li toglie di lì, il Salva manda l'elenco)
  const comuniImparati = comuniAuto(dati, comuniDa(dati.citta_ricerca));
  const titoletto = (testo, primo) => <p className="muto" style={{ fontSize: '.78rem', margin: primo ? '0 0 .4rem' : '.9rem 0 .4rem' }}>{testo}</p>;
  return (
    <Riquadro titolo="Profilo e ricerca" chiudi={chiudi}>
      <form onSubmit={invia}>
        {titoletto('La ricerca', true)}
        <div className="form-griglia">{CAMPI_RICERCA.map(campo)}</div>
        {/* I comuni entrati da soli dagli immobili inseriti dal cliente (backend/comuni_imparati.py:
            `citta_ricerca_auto`): portano l'etichetta e la ✕ li toglie dai "Comuni" qui sopra. Salvando, il server
            si ricorda da sé che sono stati rifiutati e non li rimette più. Un comune scritto a mano non compare qui. */}
        {comuniImparati.length > 0 && (
          <div className="scelte-ricerca comuni-auto" role="group" aria-label="Comuni aggiunti dagli immobili inseriti" data-testid="comuni-auto">
            <span>Dagli immobili</span>
            {comuniImparati.map((c) => (
              <span className="chip" key={c}>
                {c} <em>aggiunto dagli immobili inseriti</em>
                <button type="button" className="x" aria-label={`Togli ${c} dai comuni della ricerca`}
                  onClick={() => setDati({ ...dati, citta_ricerca: senzaComune(comuniDa(dati.citta_ricerca), c).join(', ') })}>✕</button>
              </span>
            ))}
          </div>
        )}
        {/* la zona sulla mappa: i comuni coperti finiscono negli stessi "Comuni" qui sopra */}
        <MappaZona poligoni={zonaDi(dati)} comuni={comuniDa(dati.citta_ricerca)} idMappa="staff"
          onCambia={(poligoni, comuni) => setDati({ ...dati, zona_ricerca: poligoni, citta_ricerca: comuni.join(', ') })} />
        <div className="scelte-ricerca" role="group" aria-label="Tipo di casa"><span>Tipo di casa</span>
          {TIPI_IMMOBILE.map(([v, n]) => <Chip key={v} on={dati.tipo_immobile_ricerca.includes(v)} onClick={() => alterna('tipo_immobile_ricerca', v)}>{n}</Chip>)}</div>
        <div className="scelte-ricerca" role="group" aria-label="Piano"><span>Piano</span>
          {PIANI_RICERCA.map(([v, n]) => <Chip key={v} on={dati.piano_ricerca.includes(v)} onClick={() => alterna('piano_ricerca', v)}>{n}</Chip>)}</div>
        <div className="scelte-ricerca" role="group" aria-label="Da avere"><span>Da avere</span>
          {DA_AVERE.map(([k, n]) => <Chip key={k} on={Boolean(dati[k])} onClick={() => setDati({ ...dati, [k]: !dati[k] })}>{n}</Chip>)}</div>
        {titoletto('Mutuo')}
        <div className="form-griglia">{CAMPI_MUTUO.map(campo)}</div>
        {titoletto('Lavoro, famiglia e dati (servono per la lista dei documenti)')}
        <div className="form-griglia">{CAMPI_PROFILO.map(campo)}</div>
        {/* Il permesso di soggiorno di ogni persona del nucleo: la data scritta qui comanda su quella letta dal
            documento, e da qui partono i promemoria a 90, 60, 30 e 7 giorni (backend/permesso_soggiorno.py). */}
        {titoletto('Permesso di soggiorno (una riga per ogni persona del nucleo)')}
        <div className="permessi-nucleo" data-testid="permessi-nucleo">
          {rigaPermesso(nomeDi(dati), dati, (k, v) => setDati({ ...dati, [k]: v }), 'titolare')}
          {familiari.map((f) => rigaPermesso(nomeDi(f), permessi[f.id] || permessoDi(f),
            (k, v) => setPermessi((p) => ({ ...p, [f.id]: { ...(p[f.id] || permessoDi(f)), [k]: v } })), f.id))}
        </div>
        <datalist id="nazionalita-staff">{NAZIONALITA.map((n) => <option key={n} value={n} />)}</datalist>
        <div className="form-riga"><button type="submit" className="btn sm p">Salva</button></div>
      </form>
    </Riquadro>
  );
};

// "Fai firmare": un modulo di Impostazioni → Moduli e contratti, con i dati del cliente (si possono correggere: codice
// fiscale e indirizzo mancanti si salvano nel profilo) e gli importi; al cliente arrivano email e notifica.
const STATI_FIRMA = { da_firmare: 'da firmare', firmata: 'firmato', annullata: 'annullato' };
export const FaiFirmare = ({ cliente, chiudi, onFatto }) => {
  const [moduli, setModuli] = useState(null);
  const [firme, setFirme] = useState([]);
  const [dati, setDati] = useState({ modulo_id: '', valori: {}, importi: {}, messaggio: '' });
  const [attesa, setAttesa] = useState(false);
  const ricarica = () => axios.get(`${API}/clienti/${cliente.id}/firme`).then((r) => setFirme(r.data)).catch(() => {});
  useEffect(() => {
    axios.get(`${API}/moduli`).then((r) => setModuli(r.data)).catch(() => setModuli([]));
    axios.get(`${API}/clienti/${cliente.id}`).then((r) => setDati((d) => ({ ...d, valori: {
      nome: r.data.nome || '', cognome: r.data.cognome || '', codice_fiscale: r.data.codice_fiscale || '', indirizzo: r.data.indirizzo_residenza || '' } }))).catch(() => {});
    ricarica();
  }, [cliente.id]); // eslint-disable-line
  const modulo = (moduli || []).find((m) => m.id === dati.modulo_id);
  const valore = (k) => ({ value: dati.valori[k] || '', onChange: (e) => setDati({ ...dati, valori: { ...dati.valori, [k]: e.target.value } }) });
  const invia = async (e) => {
    e.preventDefault();
    setAttesa(true);
    try {
      await axios.post(`${API}/clienti/${cliente.id}/firme`, dati);
      toast.success(`Mandato da firmare: ${cliente.nome} riceve email e notifica`);
      ricarica();
      onFatto();
    } catch (err) { errore(err); } finally { setAttesa(false); }
  };
  const annulla = async (f) => { try { await axios.post(`${API}/firme/${f.id}/annulla`); ricarica(); } catch (err) { errore(err); } };
  return (
    <Riquadro titolo="Fai firmare" chiudi={chiudi}>
      {moduli && !moduli.length && <p className="vuoto">Nessun modulo: l'admin li carica in Impostazioni → Moduli e contratti.</p>}
      {moduli && moduli.length > 0 && (
        <form className="form-riga" onSubmit={invia} data-testid="fai-firmare">
          <select value={dati.modulo_id} onChange={(e) => setDati({ ...dati, modulo_id: e.target.value, importi: {} })} required aria-label="Modulo">
            <option value="">Quale modulo?</option>
            {moduli.map((m) => <option key={m.id} value={m.id}>{m.nome}</option>)}
          </select>
          <input placeholder="Nome" aria-label="Nome" required {...valore('nome')} />
          <input placeholder="Cognome" aria-label="Cognome" required {...valore('cognome')} />
          <input placeholder="Codice fiscale" aria-label="Codice fiscale" maxLength={16} {...valore('codice_fiscale')} />
          <input placeholder="Indirizzo di residenza" aria-label="Indirizzo di residenza" style={{ minWidth: '16rem' }} {...valore('indirizzo')} />
          {(modulo?.importi || []).map((i) => (
            <input key={i.chiave} placeholder={`${i.etichetta} (€)`} aria-label={i.etichetta} inputMode="decimal" value={dati.importi[i.chiave] || ''}
              onChange={(e) => setDati({ ...dati, importi: { ...dati.importi, [i.chiave]: e.target.value } })} />
          ))}
          <input placeholder="Messaggio (facoltativo)" aria-label="Messaggio" style={{ flex: 1, minWidth: '14rem' }} value={dati.messaggio}
            onChange={(e) => setDati({ ...dati, messaggio: e.target.value })} />
          <button type="submit" className="btn sm p" disabled={attesa}>{attesa ? 'Mando…' : 'Manda da firmare'}</button>
        </form>
      )}
      {firme.length > 0 && (
        <div className="firme-elenco" data-testid="firme-cliente">
          {firme.map((f) => (
            <div key={f.id}>
              <b>{f.nome}</b>
              <span>{STATI_FIRMA[f.stato] || f.stato}{f.firmata?.data ? ` il ${comeData(f.firmata.data).toLocaleDateString('it-IT', { day: 'numeric', month: 'short' })}` : ''}</span>
              {f.stato === 'da_firmare' && <button type="button" className="btn xs" onClick={() => annulla(f)}>Annulla</button>}
            </div>
          ))}
        </div>
      )}
    </Riquadro>
  );
};
